import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="radio-roller"
// Picks a random enabled radio option among its targets and selects it.
export default class extends Controller {
	static targets = ["option"];

	roll() {
		const radios = this.optionTargets.map((option) => option.querySelector('input[type="radio"]')).filter((radio) => radio && !radio.disabled);

		if (radios.length === 0) return;

		const radio = radios[Math.floor(Math.random() * radios.length)];
		radio.checked = true;
		radio.dispatchEvent(new Event("change", { bubbles: true }));
	}
}
